import { render, staticRenderFns } from "./EndorsementPositionModal.vue?vue&type=template&id=5b86076c&scoped=true"
import script from "./EndorsementPositionModal.vue?vue&type=script&lang=ts"
export * from "./EndorsementPositionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86076c",
  null
  
)

export default component.exports